import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  artist: belongsTo('artist', { inverse: null }),
  channel: belongsTo('channel', { inverse: null }),
});
